(() => {
  const gallerySelector = "[data-creator-gallery]";
  const categoryLabels = {
    coffee: "コーヒー",
    kitchen: "キッチン家電",
    "personal-care": "美容・パーソナルケア"
  };
  const allCategoryLabel = "すべてのカテゴリー";

  function emitGalleryEvent(action, value) {
    document.dispatchEvent(new CustomEvent("epeios:gallery", {
      detail: { action, value }
    }));
  }

  function prepareCovers(root) {
    root.querySelectorAll(".card__media img").forEach((image) => {
      const media = image.closest(".card__media");
      const showImage = () => media?.classList.add("is-loaded");
      const hideImage = () => image.remove();

      image.addEventListener("load", showImage, { once: true });
      image.addEventListener("error", hideImage, { once: true });
      if (image.complete && image.naturalWidth) showImage();
    });
  }

  function postFromCard(card) {
    const handle = card.querySelector(".card__handle");
    const caption = card.querySelector(".card__caption");
    const date = card.querySelector(".card__date");
    const image = card.querySelector(".card__media img");
    const playButton = card.querySelector("[data-play]");

    return {
      code: card.dataset.entryCode || "",
      category: card.dataset.category || "",
      handle: handle?.textContent?.trim() || "@instagram",
      caption: caption?.textContent?.trim() || "",
      dateLabel: date?.textContent?.trim() || "",
      url: handle?.href || "",
      image: image?.currentSrc || image?.src || "",
      video: playButton?.dataset.videoSrc || ""
    };
  }

  function initGallery(root) {
    if (root.dataset.galleryInitialized === "true") return;
    root.dataset.galleryInitialized = "true";

    const grid = root.querySelector("[data-gallery-grid]");
    const modal = root.querySelector("[data-gallery-modal]");
    const pageContent = root.querySelector(".gallery");
    const emptyState = root.querySelector("[data-empty-state]");
    const visibleCount = root.querySelector("[data-visible-count]");
    const activeCategory = root.querySelector("[data-active-category]");
    if (!grid || !modal || !pageContent || !emptyState || !visibleCount || !activeCategory) return;

    const modalVideoHost = modal.querySelector("[data-modal-video-host]");
    const modalCloseButton = modal.querySelector(".modal__close");
    const modalCategory = modal.querySelector("[data-modal-category]");
    const modalTitle = modal.querySelector("[data-modal-title]");
    const modalCreator = modal.querySelector("[data-modal-creator]");
    const modalCaption = modal.querySelector("[data-modal-caption]");
    const modalLink = modal.querySelector("[data-modal-link]");
    let activePlayButton = null;
    let activePostCode = "";

    function updateResultCount(count, category = "all") {
      visibleCount.textContent = String(count);
      activeCategory.textContent = category === "all"
        ? allCategoryLabel
        : categoryLabels[category] || allCategoryLabel;
    }

    function loadVideo(post) {
      modalVideoHost.classList.remove("is-loaded");
      modalVideoHost.replaceChildren();

      if (!post.video) {
        const errorMessage = document.createElement("p");
        errorMessage.className = "modal__video-error";
        errorMessage.textContent = "動画を読み込めません。";
        modalVideoHost.append(errorMessage);
        return;
      }

      const spinner = document.createElement("span");
      spinner.className = "modal__spinner";
      spinner.setAttribute("aria-hidden", "true");

      const video = document.createElement("video");
      video.className = "modal__video";
      video.src = post.video;
      video.poster = post.image;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.preload = "metadata";
      video.setAttribute("playsinline", "");
      video.setAttribute("aria-label", `${post.handle}のInstagram動画`);
      video.addEventListener("canplay", () => modalVideoHost.classList.add("is-loaded"), { once: true });
      video.addEventListener("error", () => {
        video.remove();
        spinner.remove();
        const errorMessage = document.createElement("p");
        errorMessage.className = "modal__video-error";
        errorMessage.textContent = "動画を読み込めません。";
        modalVideoHost.append(errorMessage);
      }, { once: true });

      modalVideoHost.append(spinner, video);
      video.play().catch(() => {});
    }

    function openModal(post, trigger) {
      activePlayButton = trigger;
      activePostCode = post.code;
      modalCategory.textContent = categoryLabels[post.category] || allCategoryLabel;
      modalTitle.textContent = post.code ? `投稿コード ${post.code}` : post.handle;
      modalCreator.textContent = [post.handle, post.dateLabel].filter(Boolean).join(" / ");
      modalCaption.textContent = post.caption;
      modalLink.href = post.url;
      modal.setAttribute("aria-hidden", "false");
      pageContent.inert = true;
      document.body.classList.add("creator-gallery-modal-open");
      loadVideo(post);
      modalCloseButton?.focus();
      emitGalleryEvent("video_open", post.code);
    }

    function closeModal() {
      if (modal.getAttribute("aria-hidden") === "true") return;
      modal.setAttribute("aria-hidden", "true");
      pageContent.inert = false;
      document.body.classList.remove("creator-gallery-modal-open");
      const video = modalVideoHost.querySelector("video");
      if (video) {
        video.pause();
        video.removeAttribute("src");
        video.load();
      }
      modalVideoHost.classList.remove("is-loaded");
      modalVideoHost.replaceChildren();
      activePlayButton?.focus();
      activePlayButton = null;
      activePostCode = "";
    }

    function setDensity(value, persist = false) {
      const density = value === "compact" ? "compact" : "regular";
      grid.dataset.density = density;
      root.querySelectorAll("[data-density]").forEach((item) => {
        const isActive = item.dataset.density === density;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-pressed", String(isActive));
      });
      if (persist) {
        try {
          localStorage.setItem("epeiosCreatorGalleryDensity", density);
        } catch {}
        emitGalleryEvent("density_change", density);
      }
    }

    prepareCovers(root);
    updateResultCount(grid.querySelectorAll(".card").length);

    grid.addEventListener("click", (event) => {
      const playButton = event.target.closest("[data-play]");
      if (playButton) {
        const card = playButton.closest(".card");
        if (card) openModal(postFromCard(card), playButton);
        return;
      }

      const instagramLink = event.target.closest("[data-instagram-link]");
      if (instagramLink) {
        const card = instagramLink.closest(".card");
        emitGalleryEvent("instagram_click", card?.dataset.entryCode || "");
      }
    });

    root.querySelectorAll("[data-filter]").forEach((filter) => {
      filter.addEventListener("click", () => {
        const value = filter.dataset.filter;
        root.querySelectorAll("[data-filter]").forEach((item) => {
          const isActive = item === filter;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-pressed", String(isActive));
        });

        let visiblePosts = 0;
        grid.querySelectorAll(".card").forEach((card) => {
          card.hidden = value !== "all" && card.dataset.category !== value;
          if (!card.hidden) visiblePosts += 1;
        });
        emptyState.hidden = visiblePosts > 0;
        updateResultCount(visiblePosts, value);
        emitGalleryEvent("filter_change", value);
      });
    });

    root.querySelectorAll("[data-density]").forEach((option) => {
      option.addEventListener("click", () => setDensity(option.dataset.density, true));
    });

    try {
      setDensity(localStorage.getItem("epeiosCreatorGalleryDensity"));
    } catch {
      setDensity("regular");
    }

    modalLink?.addEventListener("click", () => emitGalleryEvent("instagram_click", activePostCode));
    modal.querySelectorAll("[data-close]").forEach((button) => button.addEventListener("click", closeModal));

    root.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeModal();
        return;
      }
      if (event.key !== "Tab" || modal.getAttribute("aria-hidden") === "true") return;

      const focusableElements = [...modal.querySelectorAll("button:not([disabled]), a[href], video[controls]")];
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement?.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement?.focus();
      }
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(gallerySelector).forEach(initGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
